module.exports = (__webpack_require__(2))("./core/framework/app.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/framework/app.js from dll-reference base
// module id = 95
// module chunks = 22